const quicklinkEls = document.querySelectorAll(".metanav__quicklinks");

try {
  quicklinkEls.forEach((quicklinkEl) => {
    const btnEl = quicklinkEl.querySelector(".metanav__quicklinks__button");
    const overlayEl = quicklinkEl.querySelector(".metanav__quicklinks__overlay");

    if (btnEl && overlayEl) {
      document.addEventListener("click", (e) => {
        const isActive = btnEl.classList.contains("active");
        const btnElClicked = e.target === btnEl || btnEl.contains(e.target);
        const overlayElClicked = e.target === overlayEl || overlayEl.contains(e.target);

        if (!isActive && btnElClicked) {
          btnEl.classList.add("active");
          overlayEl.classList.add("active");
        } else if (!overlayElClicked) {
          btnEl.classList.remove("active");
          overlayEl.classList.remove("active");
        }
      });
    }
  });
} catch (error) {
  console.log(error);
}
